import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, FileText, Target, BookOpen, ShieldCheck, ArrowRight, Server, ChevronRight } from 'lucide-react';

const DocsHome = () => {
    return (
        <div style={{ animation: 'fadeIn 0.3s ease-out' }}>
            <div style={{ marginBottom: '4rem', textAlign: 'center' }}>
                <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: 'rgba(var(--primary-rgb), 0.1)', color: 'var(--primary)', padding: '6px 14px', borderRadius: 99, fontSize: '0.8rem', fontWeight: 800, marginBottom: '1.5rem' }}>
                    ugra v2.0 Dokümantasyon
                </div>
                <h1 style={{ fontSize: '3rem', fontWeight: 900, marginBottom: '1rem', letterSpacing: '-0.02em' }}>
                    Nasıl yardımcı olabiliriz?
                </h1>
                <p style={{ color: 'var(--text-muted)', fontSize: '1.1rem', maxWidth: 600, margin: '0 auto', lineHeight: 1.6 }}>
                    Platform entegrasyonları, mimari detaylar ve kullanım kılavuzlarına buradan ulaşabilirsiniz.
                </p>
            </div>

            <style>{`
                .docs-card { 
                    background: var(--bg-card); 
                    border: 1px solid var(--border); 
                    border-radius: 16px; 
                    padding: 2rem; 
                    text-decoration: none;
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;
                    transition: all 0.3s;
                    position: relative;
                    overflow: hidden;
                }
                .docs-card:hover { 
                    border-color: var(--primary); 
                    box-shadow: 0 10px 30px rgba(0,0,0,0.05);
                    transform: translateY(-2px);
                }
                .docs-card-icon {
                    width: 48px; height: 48px; border-radius: 12px;
                    display: flex; alignItems: center; justifyContent: center;
                }
                .docs-card-arrow {
                    position: absolute;
                    bottom: 2rem;
                    right: 2rem;
                    color: var(--primary);
                    opacity: 0;
                    transform: translateX(-10px);
                    transition: all 0.3s;
                }
                .docs-card:hover .docs-card-arrow {
                    opacity: 1;
                    transform: translateX(0);
                }
                @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
            `}</style>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem', marginBottom: '4rem' }}>
                <Link to="/getting-started" className="docs-card">
                    <div className="docs-card-icon" style={{ background: 'rgba(16, 185, 129, 0.1)', color: '#10b981' }}>
                        <Zap size={24} />
                    </div>
                    <div>
                        <h2 style={{ fontSize: '1.25rem', fontWeight: 800, color: 'var(--text-main)', marginBottom: '0.5rem' }}>Hızlı Başlangıç</h2>
                        <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', lineHeight: 1.6 }}>Platformun temel özellikleri ve ilk kurulum yönergeleri.</p>
                    </div>
                    <ArrowRight className="docs-card-arrow" />
                </Link>

                <Link to="/whitepaper" className="docs-card">
                    <div className="docs-card-icon" style={{ background: 'rgba(99, 102, 241, 0.1)', color: '#6366f1' }}>
                        <FileText size={24} />
                    </div>
                    <div>
                        <h2 style={{ fontSize: '1.25rem', fontWeight: 800, color: 'var(--text-main)', marginBottom: '0.5rem' }}>Whitepaper</h2>
                        <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', lineHeight: 1.6 }}>Mimari yapı, teknoloji yığını ve pazar değerlendirmesi.</p>
                    </div>
                    <ArrowRight className="docs-card-arrow" />
                </Link>

                <Link to="/roadmap" className="docs-card">
                    <div className="docs-card-icon" style={{ background: 'rgba(var(--primary-rgb), 0.1)', color: 'var(--primary)' }}>
                        <Target size={24} />
                    </div>
                    <div>
                        <h2 style={{ fontSize: '1.25rem', fontWeight: 800, color: 'var(--text-main)', marginBottom: '0.5rem' }}>Yol Haritası</h2>
                        <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', lineHeight: 1.6 }}>Gelecek çeyrek planları ve platform güncellemeleri.</p>
                    </div>
                    <ArrowRight className="docs-card-arrow" />
                </Link>

                <Link to="/api" className="docs-card">
                    <div className="docs-card-icon" style={{ background: 'rgba(236, 72, 153, 0.1)', color: '#ec4899' }}>
                        <BookOpen size={24} />
                    </div>
                    <div>
                        <h2 style={{ fontSize: '1.25rem', fontWeight: 800, color: 'var(--text-main)', marginBottom: '0.5rem' }}>API & Entegrasyon</h2>
                        <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', lineHeight: 1.6 }}>Dış servis bağlantıları, webhooks ve API yetenekleri.</p>
                    </div>
                    <ArrowRight className="docs-card-arrow" />
                </Link>
            </div>

            <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: '16px', padding: '2.5rem', display: 'flex', gap: '2rem', alignItems: 'center', flexWrap: 'wrap' }}>
                <div style={{ flex: 1, minWidth: '300px' }}>
                    <h3 style={{ fontSize: '1.5rem', fontWeight: 800, marginBottom: '0.75rem', display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Server size={24} style={{ color: 'var(--primary)' }} /> Sistem Durumu
                    </h3>
                    <p style={{ color: 'var(--text-muted)', fontSize: '0.95rem', lineHeight: 1.6, marginBottom: '1.5rem' }}>
                        Tüm servisler şu an operasyonel durumda. API yanıt süreleri ve Supabase WebSocket bağlantıları normal değerlerde ({"<"} 50ms).
                    </p>
                    <a href="#" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', color: 'var(--primary)', fontWeight: 700, textDecoration: 'none', fontSize: '0.9rem' }}>
                        Status Page'e Git <ChevronRight size={16} />
                    </a>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                    <div style={{ background: 'var(--bg-main)', padding: '1.5rem', borderRadius: '12px', border: '1px solid var(--border)' }}>
                        <div style={{ color: 'var(--text-muted)', fontSize: '0.75rem', fontWeight: 700, textTransform: 'uppercase', marginBottom: '0.5rem' }}>API Çalışma Süresi</div>
                        <div style={{ fontSize: '1.5rem', fontWeight: 900, color: '#10b981' }}>%99.99</div>
                    </div>
                    <div style={{ background: 'var(--bg-main)', padding: '1.5rem', borderRadius: '12px', border: '1px solid var(--border)' }}>
                        <div style={{ color: 'var(--text-muted)', fontSize: '0.75rem', fontWeight: 700, textTransform: 'uppercase', marginBottom: '0.5rem' }}>Ortalama Yanıt</div>
                        <div style={{ fontSize: '1.5rem', fontWeight: 900, color: 'var(--text-main)' }}>42ms</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DocsHome;
